import { SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';

import { UserInfoType } from '../../../common/type/UserInfoType';
import { responseType } from '../../../common/type/ResponseType';
import { permission } from '../../../common/const/commonConst';

import { loginHandler } from '../../feature/handler/loginHandler';
import { OffsegAuthInfoType } from '../../feature/type/AuthInfoType';

type InputType = {
	setIsAsyncProcess: (value: SetStateAction<boolean>) => void;
	isChecked: boolean;
	offsegLoginAuthInfo: OffsegAuthInfoType;
	offsegReregistrationAuthInfo: OffsegAuthInfoType;
	isReregistrationDialogStep1Opened: boolean;
	setUserInfo: React.Dispatch<React.SetStateAction<UserInfoType>>;
	setIsLoginError: (value: React.SetStateAction<boolean>) => void;
	setIsLoginLockError: (value: React.SetStateAction<boolean>) => void;
	setIsReregistrationDialogStep1Opened: (value: React.SetStateAction<boolean>) => void;
	setIsReregistrationDialogStep2Opened: (value: React.SetStateAction<boolean>) => void;
	setIsRegistrationDialogOpened: (value: React.SetStateAction<boolean>) => void;
	setNeedsChangeInitPassword: (value: React.SetStateAction<boolean>) => void;
	setIsLocalStorageError: (value: React.SetStateAction<boolean>) => void;
};

/**
 * ログイン用カスタムフック
 */
export const usePostLogin = (input: InputType) => {
	const navigate = useNavigate();

	const {
		setIsAsyncProcess,
		isChecked,
		offsegLoginAuthInfo,
		offsegReregistrationAuthInfo,
		isReregistrationDialogStep1Opened,
		setUserInfo,
		setIsLoginError,
		setIsLoginLockError,
		setIsReregistrationDialogStep1Opened,
		setIsReregistrationDialogStep2Opened,
		setIsRegistrationDialogOpened,
		setNeedsChangeInitPassword,
		setIsLocalStorageError,
	} = input;

	// ログインボタンを押下した際の処理
	const onClickLogin = async () => {
		setIsAsyncProcess(true);

		const offsegAuthInfo = (isReregistrationDialogStep1Opened) ? offsegReregistrationAuthInfo : offsegLoginAuthInfo;

		const [responseNum, permissionNum] = await loginHandler(offsegAuthInfo, isChecked, isReregistrationDialogStep1Opened, setUserInfo);

		setIsAsyncProcess(false);
		setIsLoginError(false);
		setIsLoginLockError(false);
		setIsLocalStorageError(false);

		switch (responseNum) {
			case responseType.success:
				if (permissionNum === permission.id.driver) {
					navigate('/car-use-result');
					return;
				}

				navigate('/current-car-place');
				return;

			case responseType.notExistApiResponseData:
				setIsLoginError(true);
				return;

			case responseType.loginLockError:
				setIsLoginLockError(true);
				return;

			case responseType.apiError:
				setIsLoginError(true);
				return;

			case responseType.dbError:
				setIsLoginError(true);
				return;

			case responseType.systemError:
				setIsLoginError(true);
				return;

			case responseType.validationError:
				setIsLoginError(true);
				return;

			case responseType.unregisteredAccount:
				setIsReregistrationDialogStep1Opened(false);
				setIsRegistrationDialogOpened(true);
				return;

			case responseType.reqeustChangeInitialPassword:
				setNeedsChangeInitPassword(true);
				return;

			case responseType.reregistrationStep1Success:
				setIsReregistrationDialogStep1Opened(false);
				setIsReregistrationDialogStep2Opened(true);
				return;

			case responseType.WebStorageError:
				setIsLocalStorageError(true);
				return;
		}
	};

	return { onClickLogin };
};
